export default __webpack_public_path__ + "static/media/circle.7c5d013d.svg";